import { render, staticRenderFns } from "./AddCompanyButton.vue?vue&type=template&id=3f044908&scoped=true"
var script = {}
import style0 from "./AddCompanyButton.vue?vue&type=style&index=0&id=3f044908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f044908",
  null
  
)

export default component.exports